// extracted by mini-css-extract-plugin
module.exports = {"stack":"style_stack__11WOX"};